import { ParamsPostDelete, ParamsPostUpdate } from 'app/dataTypes/org/dietFoodTypes'
import type { Request } from '../../../index'

type UrlParams = {
  id: number,
}

type ApiParams = {
  add_id?: number, // id из списка дилера, добавляемое в список школы
  remove_id?: number, // id, удаляемое из списка школы
  set_ids?: Array<number> // сохраняемый список id
}

export const convertParamsDelete = (params: ParamsPostDelete): [ApiParams, UrlParams] => {
  const result: ApiParams = {
    remove_id: parseInt(params.removeId, 10),
  }
  return [result, { id: parseInt(params.orgId, 10) }]
}

export const convertParamsUpdate = (params: ParamsPostUpdate): [ApiParams, UrlParams] => {
  const result: ApiParams = {
    set_ids: params.setIds.map(i => parseInt(i, 10)),
  }
  return [result, { id: parseInt(params.orgId, 10) }]
}


type ApiResult = {
  result: 'success',
}

export const convertResult = (result: ApiResult): true => {
  return !!result
}

export const POST_SCHOOL_DIET_FOOD_TYPES: Request<ParamsPostDelete | ParamsPostUpdate, true, void> = [
  'food/schools/{id}/diet_food_types',
  'post',
  ['data'],
]
